<template>
  <div>
    <!-- :mini-variant="drawer" -->
    <v-navigation-drawer
      app
      v-model="isOpen"
      class="personal-shadow"
      floating
      width="300"
      src="https://titansoluciones.cloud/img/12fondomenu.png"
    >
      <v-list-item>
        <v-list-item-content>
          <v-img
            :src="logo_empresa"
            contain
            class="white mx-auto"
            height="120"
            max-width="120%"
            max-height="100"
          ></v-img>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-6" :style="{ 'border-width': '1px', 'border-color': 'orange' }" />
      


      <v-list>
        <v-list-item
          link
          class="mb-0"
          :to="item.ruta"
          v-for="(item, index) in opciones"
          v-show="!item.submenu"
          :key="index + 'sub'"
        >
          <v-list-item-icon >
            <v-icon size="26" color="orange">mdi-home-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="black--text subtitle-1">Principal</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-group
          no-action
          :prepend-icon="item.icono"
          v-for="(item, index) in opciones"
          :key="index"
          v-model="item.active"
          v-show="validar_menu(item)"
          :color="getColorMenu(index)"
        > -->
        <v-list-group
          no-action
          :prepend-icon="item.icono"
          v-for="(item, index) in opciones"
          :key="index"
          v-model="item.active"
          v-show="validar_menu(item)"
        >

          <template v-slot:activator>
            <v-list-item-content :class="`d-inline pa-2 black--text rounded-pill text-center ${
              getColorMenu(index)}`">
              <v-list-item-title>{{ item.text }} </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(sub, j) in item.submenu"
            :key="j + 'sub'"
            :to="item.ruta + sub.href"
            link
            v-show="!sub.submenu2 ? validar_submenu(sub) : false"
          >
            <v-list-item-icon>
              <v-icon :color="getColorIcon(index)" size="30">{{ sub.icono }}</v-icon>
              <!-- <v-icon :color="getColorMenu(index)" size="30">{{ sub.icono }}</v-icon> -->
            </v-list-item-icon>
            <v-list-item-title>{{ sub.text }}</v-list-item-title>
          </v-list-item>

          
      <!-- Submenu -->
          <v-list-group
            sub-group
            no-action
            dense
            v-for="(sub, j) in item.submenu"
            :key="j"
            link
            :append-icon="sub.icono"
            v-model="sub.active"
            v-show="sub.submenu2 ? validar_submenu(sub) : false"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ sub.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              no-action
              dense
              v-for="(submenu, i) in sub.submenu2"
              :key="i"
              :to="item.ruta + submenu.href"
              link
              exact
              v-show="validar_submenu(submenu)"
            >
              <v-list-item-icon>
               <v-icon 
                  :color="getColorIcon(index)"
                  size="30"
                  v-text="submenu.icono"
                >
                </v-icon>

              </v-list-item-icon>


              <!-- <v-list-item-icon>
               <v-icon 
                  :color="getColorMenu(index)"
                  size="30"
                  v-text="submenu.icono"
                >
                </v-icon>

              </v-list-item-icon> -->
              <v-list-item-title v-text="submenu.text"></v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import post from "../methods.js";

export default {
  name: "Nav",
  props: {
    drawer: Boolean,
  },
  data: () => ({
    isOpen: true,
    logo_empresa: null,
    opciones: [],
    filtro_opciones: [],
  }),
  created() {
    this.logo_empresa =
      "https://server1ts.net/datos/image/clientes/" +
      `${parseFloat(sessionStorage.Sesion.substr(0, 15))}` +
      ".png";
    this.get_cargue();
  },
  methods: {
    get_cargue: function () {
      const { path } = this.$route;
      const modulo = path.split("/")[2];
      post
        .postData({
          url: "Financiero/dlls/Menu01J.dll",
          data: sessionStorage.Sesion + "|" + modulo + "|",
          method: "",
        })
        .then((data) => {
          data.pop();
          this.filtro_opciones = data;
          this.validar();
        })
        .catch((err) => {
          this.$emit("snack", {
            color: "error",
            text: "Error al cargar menus",
            estado: true,
          });
        });
    },

    validar_menu(item) {
      if (!item.submenu) return false;
      else {
        let find = this.filtro_opciones.find((el) => el.ruta_rep === item.id);
        return find ? find.estado_rep === "1" : true;
      }
      
    },
    validar_submenu(item) {
      let find = this.filtro_opciones.find((el) => el.ruta_rep === item.id);
      return find ? find.estado_rep === "1" : true;
    },
    validar() {
      var ruta = this.$route.path.split("/")[2];
      var modulo = this.$route.params.modulo || ruta;
      if (modulo) {
        var nav = this.nav_menu[modulo];
        if (nav) this.opciones = nav;
        else this.$router.push({ path: "/" });
      }
    },
    getColorMenu(index){
      if(index === 1) return 'green lighten-3'
      else if(index === 2) return 'blue accent-2'
      else if(index === 3) return 'indigo lighten-4'
    },
    getColorIcon(index){
      if(index === 1) return 'green darken-3'
      else if(index === 2) return 'blue darken-1'
      else if(index === 3) return 'purple dark'
    }    
  },
  watch: {
    drawer: function (estado) {
      if (estado == this.estado) this.isOpen = !estado;
      else this.isOpen = estado;
    },
  },
};
</script>
<style lang="sass">
.v-application--is-ltr .v-list-group--no-action.v-list-group--sub-group > .v-list-group__items > .v-list-item
  padding-left: 40px!important

.v-application .primary--text
  color: var(--v-info-darken2) !important
  caret-color: var(--v-info-darken2) !important

.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > div >
  .v-list-item
    padding-left: 40px!important

.v-list-item__title,
.v-list-item--dense .v-list-item__title
  font-size: 14px!important
  font-weight: 400!important

.v-navigation-drawer
  max-height: 100%!important

.v-navigation-drawer .v-list .v-list-item--active
  box-shadow: inset 4px 0px 0px
  color: var(--v-yellow-darken2) !important  
</style>